import envVars from 'helpers/envVars';
import request from 'helpers/request';
import buildHTTPResponseHandler from 'helpers/buildHTTPResponseHandler';

import * as DTO from './dto';

const domain = envVars('API_PAINEL_DIGITAL_BASE_URL');

const serviceName = 'notifications';

export async function getNotifications({
  userId,
  ...rest
}: DTO.GetNotificationsQ) {
  const formattedParams: Omit<DTO.GetNotificationsQ, 'userId'> = {
    ...rest,
    ...(rest?.proposalId && { proposalId: rest.proposalId }),
    ...(rest?.read !== undefined && { read: rest.read }),
    ...(rest?.type && { type: rest.type }),
  };

  const response = await request
    .get<DTO.GetNotificationsR>(
      `${domain}/notification/user/${userId}`,
      formattedParams
    )
    .then(response => {
      buildHTTPResponseHandler(`${serviceName}.getNotifications()`);
      return response?.data;
    });

  return response?.content ?? [];
}

export async function readNotification({
  notificationId,
}: DTO.ReadNotificationQ) {
  const response = await request
    .put(`${domain}/notification/${notificationId}/read`)
    .then(response => {
      buildHTTPResponseHandler(`${serviceName}.readNotification()`);
      return !!response;
    });

  return response;
}

export async function readNotifications({ userId }: DTO.ReadNotificationsQ) {
  const response = await request
    .post<DTO.GetNotificationsR>(`${domain}/notification/user/${userId}`)
    .then(response => {
      buildHTTPResponseHandler(`${serviceName}.readNotifications()`);
      return response?.data;
    });

  return response?.content ?? [];
}
